import { PALETTE } from '../StageData';
import { ShadingPipeline } from '../../engine/ShadingPipeline';
import type { ShapeDrawFn } from './furnitureShapes';

export const vehicleDrawFns: Record<number, ShapeDrawFn> = {
  // STAGE 11: レーシング・ミニカー
  11: (ctx, cx, cy, mode) => {
    const drawCarBody = () => {
      ctx.beginPath();
      ctx.moveTo(cx - 150, cy + 30);
      ctx.lineTo(cx - 130, cy - 20);
      ctx.bezierCurveTo(cx - 90, cy - 60, cx + 50, cy - 60, cx + 110, cy - 10);
      ctx.lineTo(cx + 150, cy + 30);
      ctx.lineTo(cx - 150, cy + 30);
      ctx.closePath();
    };
    const drawWheels = () => {
      ctx.beginPath();
      ctx.arc(cx - 90, cy + 45, 30, 0, Math.PI * 2);
      ctx.arc(cx + 90, cy + 45, 30, 0, Math.PI * 2);
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5';
      drawWheels(); ctx.fill();
      drawCarBody(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawWheels(); ctx.stroke();
        drawCarBody(); ctx.stroke();
        ctx.beginPath();
        ctx.arc(cx - 90, cy + 45, 14, 0, Math.PI * 2);
        ctx.arc(cx + 90, cy + 45, 14, 0, Math.PI * 2);
        ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(cx - 20, cy - 50); ctx.lineTo(cx - 20, cy + 30);
        ctx.moveTo(cx + 20, cy - 50); ctx.lineTo(cx + 20, cy + 30);
        ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = PALETTE.black; drawWheels(); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 20, 300, 100, PALETTE.deepBlue, 'metallic');
      drawCarBody(); ctx.fill();
      ctx.fillStyle = PALETTE.white;
      ctx.fillRect(cx - 20, cy - 55, 40, 85);
      ShadingPipeline.renderSpecularGlint(ctx, cx - 20, cy - 35, 65, 16, 0.6);
    }
  },

  // STAGE 12: 塗聖のサーフボード
  12: (ctx, cx, cy, mode) => {
    const drawSurfboard = () => {
      ctx.beginPath();
      ctx.ellipse(cx, cy, 65, 175, 0, 0, Math.PI * 2);
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawSurfboard(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawSurfboard(); ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(cx, cy - 175); ctx.lineTo(cx, cy + 175);
        ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      const grad = ctx.createLinearGradient(cx, cy - 175, cx, cy + 175);
      grad.addColorStop(0, PALETTE.cyan);
      grad.addColorStop(0.5, PALETTE.gold);
      grad.addColorStop(1, PALETTE.coral);
      ctx.fillStyle = grad; drawSurfboard(); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 22, cy - 40, 18, 70, 0.55);
    }
  },

  // STAGE 13: カフェレーサー・バイク
  13: (ctx, cx, cy, mode) => {
    const drawWheels = () => {
      ctx.beginPath();
      ctx.arc(cx - 105, cy + 50, 48, 0, Math.PI * 2);
      ctx.arc(cx + 105, cy + 50, 48, 0, Math.PI * 2);
    };
    const drawTank = () => {
      ctx.beginPath();
      ctx.ellipse(cx - 15, cy - 30, 65, 30, -0.15, 0, Math.PI * 2);
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5';
      drawWheels(); ctx.fill();
      drawTank(); ctx.fill();
      ctx.fillRect(cx - 40, cy, 80, 50);
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawWheels(); ctx.stroke();
        drawTank(); ctx.stroke();
        ctx.strokeRect(cx - 40, cy, 80, 50);
        ctx.beginPath(); ctx.arc(cx - 105, cy + 50, 24, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx + 105, cy + 50, 24, 0, Math.PI * 2); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = PALETTE.black; drawWheels(); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 25, 80, 50, PALETTE.silver, 'metallic');
      ctx.fillRect(cx - 40, cy, 80, 50);
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx - 15, cy - 30, 130, 60, PALETTE.crimson, 'lacquer');
      drawTank(); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 35, cy - 40, 30, 10, 0.6);
    }
  },

  // STAGE 14: レトロスクールバス
  14: (ctx, cx, cy, mode) => {
    const drawBus = () => {
      ctx.beginPath();
      ctx.roundRect(cx - 140, cy - 70, 280, 125, 18);
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawBus(); ctx.fill();
      ctx.beginPath(); ctx.arc(cx - 75, cy + 55, 26, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx + 75, cy + 55, 26, 0, Math.PI * 2); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawBus(); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx - 75, cy + 55, 26, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx + 75, cy + 55, 26, 0, Math.PI * 2); ctx.stroke();
        ctx.strokeRect(cx - 130, cy - 50, 45, 35);
        ctx.strokeRect(cx - 70, cy - 50, 45, 35);
        ctx.strokeRect(cx - 10, cy - 50, 45, 35);
        ctx.strokeRect(cx + 50, cy - 50, 45, 35);
        ctx.beginPath();
        ctx.moveTo(cx - 140, cy + 10); ctx.lineTo(cx + 140, cy + 10);
        ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 10, 280, 125, PALETTE.yellow, 'lacquer');
      drawBus(); ctx.fill();
      ctx.fillStyle = PALETTE.black;
      ctx.fillRect(cx - 140, cy + 5, 280, 15);
      ctx.beginPath(); ctx.arc(cx - 75, cy + 55, 26, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx + 75, cy + 55, 26, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.cyan;
      ctx.fillRect(cx - 130, cy - 50, 45, 35);
      ctx.fillRect(cx - 70, cy - 50, 45, 35);
      ctx.fillRect(cx - 10, cy - 50, 45, 35);
      ctx.fillRect(cx + 50, cy - 50, 45, 35);
      ShadingPipeline.renderSpecularGlint(ctx, cx - 60, cy - 60, 60, 12, 0.45);
    }
  },

  // STAGE 15: クラシック蒸気機関車
  15: (ctx, cx, cy, mode) => {
    const drawTrain = () => {
      ctx.beginPath();
      ctx.roundRect(cx - 110, cy - 55, 160, 95, 8);
      ctx.roundRect(cx + 50, cy - 105, 80, 145, 6);
      ctx.rect(cx - 95, cy - 115, 30, 60);
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawTrain(); ctx.fill();
      ctx.beginPath();
      for (let i = -1; i <= 1; i++) ctx.arc(cx - 20 + i * 55, cy + 55, 26, 0, Math.PI * 2);
      ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawTrain(); ctx.stroke();
        for (let i = -1; i <= 1; i++) {
          ctx.beginPath(); ctx.arc(cx - 20 + i * 55, cy + 55, 26, 0, Math.PI * 2); ctx.stroke();
        }
        ctx.strokeRect(cx + 65, cy - 90, 45, 45);
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 10, 240, 150, PALETTE.black, 'metallic');
      drawTrain(); ctx.fill();
      ctx.fillStyle = PALETTE.crimson; ctx.fillRect(cx - 120, cy + 30, 260, 15);
      ctx.fillStyle = PALETTE.brass; ctx.fillRect(cx - 50, cy - 70, 25, 20);
      ctx.fillStyle = PALETTE.black;
      for (let i = -1; i <= 1; i++) {
        ctx.beginPath(); ctx.arc(cx - 20 + i * 55, cy + 55, 26, 0, Math.PI * 2); ctx.fill();
      }
      ShadingPipeline.renderSpecularGlint(ctx, cx - 40, cy - 40, 50, 16, 0.4);
    }
  },

  // STAGE 16: プロペラ複葉機
  16: (ctx, cx, cy, mode) => {
    const drawPlane = () => {
      ctx.beginPath();
      ctx.ellipse(cx, cy, 140, 30, 0, 0, Math.PI * 2);
      ctx.roundRect(cx - 30, cy - 90, 60, 18, 6);
      ctx.roundRect(cx - 30, cy + 65, 60, 18, 6);
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawPlane(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawPlane(); ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(cx - 15, cy - 72); ctx.lineTo(cx - 15, cy + 65);
        ctx.moveTo(cx + 15, cy - 72); ctx.lineTo(cx + 15, cy + 65);
        ctx.stroke();
        ctx.beginPath(); ctx.ellipse(cx - 140, cy, 8, 45, 0, 0, Math.PI * 2); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 280, 60, PALETTE.deepBlue, 'lacquer');
      ctx.beginPath(); ctx.ellipse(cx, cy, 140, 30, 0, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 90, 60, 18, PALETTE.gold, 'lacquer');
      ctx.beginPath(); ctx.roundRect(cx - 30, cy - 90, 60, 18, 6); ctx.fill();
      ctx.beginPath(); ctx.roundRect(cx - 30, cy + 65, 60, 18, 6); ctx.fill();
      ctx.fillStyle = PALETTE.silver;
      ctx.beginPath(); ctx.ellipse(cx - 140, cy, 8, 45, 0, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 20, cy - 10, 55, 10, 0.5);
    }
  },

  // STAGE 17: レスキュー・ヘリコプター
  17: (ctx, cx, cy, mode) => {
    const drawChopper = () => {
      ctx.beginPath();
      ctx.ellipse(cx - 20, cy + 10, 95, 60, 0, 0, Math.PI * 2);
      ctx.moveTo(cx + 60, cy); ctx.lineTo(cx + 150, cy - 15); ctx.lineTo(cx + 150, cy - 35); ctx.lineTo(cx + 55, cy - 10);
      ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawChopper(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawChopper(); ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(cx - 120, cy - 65); ctx.lineTo(cx + 80, cy - 65);
        ctx.stroke();
        ctx.strokeRect(cx - 25, cy - 65, 10, 25);
        ctx.beginPath();
        ctx.moveTo(cx - 90, cy + 85); ctx.lineTo(cx + 50, cy + 85);
        ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 200, 120, PALETTE.orange, 'lacquer');
      drawChopper(); ctx.fill();
      ctx.fillStyle = PALETTE.white;
      ctx.beginPath(); ctx.arc(cx - 65, cy + 10, 30, Math.PI * 0.5, Math.PI * 1.5); ctx.fill();
      ctx.fillStyle = PALETTE.dark;
      ctx.fillRect(cx - 120, cy - 68, 200, 6);
      ShadingPipeline.renderSpecularGlint(ctx, cx - 40, cy - 15, 35, 18, 0.5);
    }
  },

  // STAGE 18: 黄色い深海潜水艦
  18: (ctx, cx, cy, mode) => {
    const drawSub = () => {
      ctx.beginPath();
      ctx.ellipse(cx, cy + 15, 130, 75, 0, 0, Math.PI * 2);
      ctx.roundRect(cx - 35, cy - 75, 70, 45, 10);
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawSub(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawSub(); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx - 60, cy + 15, 18, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx, cy + 15, 18, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx + 60, cy + 15, 18, 0, Math.PI * 2); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 15, 260, 150, PALETTE.yellow, 'lacquer');
      drawSub(); ctx.fill();
      ctx.fillStyle = PALETTE.crimson; ctx.fillRect(cx - 130, cy + 50, 260, 12);
      ctx.fillStyle = PALETTE.cyan;
      ctx.beginPath(); ctx.arc(cx - 60, cy + 15, 18, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx, cy + 15, 18, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx + 60, cy + 15, 18, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 30, cy - 15, 55, 20, 0.55);
    }
  },

  // STAGE 19: 冒険の気球ゴンドラ
  19: (ctx, cx, cy, mode) => {
    const drawBalloon = () => {
      ctx.beginPath();
      ctx.moveTo(cx, cy + 70);
      ctx.bezierCurveTo(cx - 140, cy + 20, cx - 130, cy - 130, cx, cy - 130);
      ctx.bezierCurveTo(cx + 130, cy - 130, cx + 140, cy + 20, cx, cy + 70);
      ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawBalloon(); ctx.fill();
      ctx.fillRect(cx - 30, cy + 105, 60, 45);
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawBalloon(); ctx.stroke();
        ctx.strokeRect(cx - 30, cy + 105, 60, 45);
        ctx.beginPath();
        ctx.moveTo(cx - 15, cy + 70); ctx.lineTo(cx - 25, cy + 105);
        ctx.moveTo(cx + 15, cy + 70); ctx.lineTo(cx + 25, cy + 105);
        ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 30, 260, 200, PALETTE.coral, 'cloth');
      drawBalloon(); ctx.fill();
      ctx.fillStyle = PALETTE.gold;
      ctx.beginPath(); ctx.ellipse(cx, cy - 30, 45, 95, 0, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.wood; ctx.fillRect(cx - 30, cy + 105, 60, 45);
      ShadingPipeline.renderSpecularGlint(ctx, cx - 40, cy - 65, 35, 35, 0.35);
    }
  },

  // STAGE 20: グランド・ヨット
  20: (ctx, cx, cy, mode) => {
    const drawHull = () => {
      ctx.beginPath();
      ctx.moveTo(cx - 130, cy + 70);
      ctx.lineTo(cx + 140, cy + 70);
      ctx.lineTo(cx + 90, cy + 135);
      ctx.lineTo(cx - 100, cy + 135);
      ctx.closePath();
    };
    const drawSails = () => {
      ctx.beginPath();
      ctx.moveTo(cx - 10, cy + 50); ctx.lineTo(cx - 10, cy - 145); ctx.lineTo(cx + 105, cy + 40); ctx.closePath();
      ctx.moveTo(cx - 20, cy + 50); ctx.lineTo(cx - 20, cy - 120); ctx.lineTo(cx - 95, cy + 50); ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawHull(); ctx.fill();
      ctx.fillStyle = '#FAF8F5'; drawSails(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawHull(); ctx.stroke();
        drawSails(); ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(cx - 15, cy - 150); ctx.lineTo(cx - 15, cy + 65);
        ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 100, 270, 65, PALETTE.navy, 'lacquer');
      drawHull(); ctx.fill();
      ctx.fillStyle = PALETTE.gold; ctx.fillRect(cx - 100, cy + 120, 190, 8);
      ctx.fillStyle = PALETTE.white; drawSails(); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 40, cy + 90, 45, 12, 0.5);
    }
  }
};
